export const contentData = {
  spanish:{
    layout:{
      title:'AS iViewer',
      navigation:[
          {name:'Tablas de Control',path:'/controltables'},
          {name:'Detalles',path:'/controltables/details/:id'},
      ],
      menu:null
    },
    modals:{
      warning_delete_file:{
        title:'¿Estás seguro?',
        message:'¿Realmente quieres eliminar este registro? Este proceso no puede ser revertido',
        cancelButton:'Cancelar',
        deleteButton:'Eliminar'
      },
      edit_service:{
        title:'Editar servicio',
        button:'Guardar',
        cancelButton:'Cancelar'
      }
    },
    basicform:{
      title:'Información',
      button:null,
      nodata:'Sin Registro',
      headers:{
        fixedHeaderA: ['Nombre','RFC','Estatus','Clasificación','Datos de Contacto', 'Clave CIEC',
        'Requerimiento Especial','Fecha Programada Curso Inducción'],
        fixedHeaderB: null,
        varHeader: ['Acuse de Minuta','Comentarios','Respuesta Cliente','Comentario Cliente',
        'Responsable','Notas','Horas Extra', 'Comprobante Horas', 'Cargos Extra', 'Comprobante Cargo', 
        'Cargo a Cobranza', 'Fecha de Completado'],
        extra: 'Completado'
      },

    }
  }
}
